import './Merchantduedeligence.css';
import { useState, useEffect, useRef } from "react";
import { Divider, Group, TextInput, Button, Paper, Table, Textarea, Text, Stack } from "@mantine/core";
import { Card, message, Flex, Spin, Alert } from "antd";
import { useAuthContext } from "../../Hooks/UseAuthContext";
import { useReactToPrint } from "react-to-print";









const Merchantduedeligence = ({ rectification = false, stepData, submissionDetails, onSuccess }) => {
    const { user } = useAuthContext();
    const [submitloading, setSubmitloading] = useState(false);
    const [companyProfile, setCompanyProfile] = useState(null);
    const [compliancedetails, setCompliancedetails] = useState(null);
    const [banksdetails, setbanksdetails] = useState(null);
    const [parta, setparta] = useState({
        Registered_Name_of_Company: "",
        Registered_Office_Address: "",
        Constitution: "",
        Date_of_Incorporation: "",
        Directors_of_Company: [
            {
                Director_name: "",
                Director_DIN_number: "",
            },
        ],
        Promoters_of_Company: [
            {
                Promoter_name: "",
            },
        ],
        Authorised_Signatory: [
            {
                Authorised_name: "",
                Authorised_mobile_number: "",
                Authorised_email: "",
                Authorised_DIN_number: "",
                Authorised_Share_perecentage: ""
            },
        ],
        CIN: "",
        GST: "",
        PAN: "",
        Annual_Business_Turnover_In_crorers: "",
    })
    const [partb, setpartb] = useState({
        Nature_of_Business_Use_case: "",
        Mode_of_Business: "",
        Products_or_Service_to_be_sold_by_the_merchant: "",
        Transaction_Ticket_Size: [
            {
                Service_name: "",
                Use_case_of_this_service: "",
                Expected_daily_transaction: "",
                Expected_monthly_business_for_this_service: "",
                Min_ticket_size: "",
                Max_ticket_size: "",
                Average_ticket_size: ""
            }
        ],
        Proposed_monthly_transaction_value_in_crores_to_be_processed_through: "",
        Functional_website_link: "",
        Mobile_application_details: "",
        Invoice_generated_for_a_customer_through_merchant_site_application: "",
        Merchant_services_required: "",
        Proposed_MCC_as_per_business_case: "",
    })
    const [partc, setpartc] = useState({
        Certificate_of_incorporation: "",
        Article_of_association: "",
        Memorandum_of_Association: "",
        MCA_Data: "",
        Company_PAN: "",
        Company_GST: "",
        MSME_Certificate: "",
        Cancelled_Cheque: "",
        Bank_Statement_last_3_months: "",
        Balance_Sheet_for_Past_2_Financial_Years: "",
        GST_Returns_for_Past_2_Financial_Years: "",
        List_of_Directors_on_Company_Letter_Head: "",
        Aadhar_and_PAN_and_Photo_of_all_Directors_for_KYC: "",
        List_of_Promoters_on_Company_Letter_Head: "",
        Aadhar_and_PAN_of_all_Promoters_for_KYC: "",
        Board_Resolution_for_Authorised_Signatory: "",
        Aadhar_and_PAN_and_Photo_of_Authorised_Signatory_for_KYC: "",
        Office_Photo_with_company_board_disptay: "",
        Photo_of_Authorised_Signatory_Office_with_geo_location: "",
        Merchant_Criminal_Undertaking: "",
        invoice_Generated_for_a_Customer_Through_Merchants_Site_Application: "",
    })
    const componentRef = useRef(null);

    const handlePrint = useReactToPrint({
        contentRef: componentRef,
    });
    const handleChange = (e) => {
        const { name, value } = e.target;
        setparta({ ...parta, [name]: value });
    };
    const handleChnangePartb = (e) => {
        const { name, value } = e.target;
        setpartb({ ...partb, [name]: value });
    }
    const handleChnangePartc = (e) => {
        const { name, value } = e.target;
        setpartc({ ...partc, [name]: value });
    }


    const getUserData = async () => { // for get the updated user data after company profile submission
        await fetch('https://api.boompay.in/get-user', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user}`,
            }
        });
        // const data = await response.json();
        // if (response.status === 200) {
        //     // console.log(data.user);
        //     setUserprofile(data.user);
        //     setActive(data.user.Completed_step);
        //     setLoading(false);
        // } else if (response.status === 401) {
        //     setLoading(false);
        //     console.log('Unauthorized access. Please log in again.');
        //     message.error('Unauthorized access. Please log in again.');
        // } else if (response.status === 404) {
        //     setLoading(false);
        //     console.log('User not found.');
        //     message.error('User not found.');
        // } else {
        //     setLoading(false);
        //     console.log('An error occurred while fetching user data.');
        //     message.error('An error occurred while fetching user data.');
        // }
    }
    const handelSubmit = async () => {
        const finalPartA = {
            ...parta,

            Registered_Name_of_Company: companyProfile?.Company_name || "",
            CIN: companyProfile?.Company_CIN_number || "",
            PAN: companyProfile?.Company_PAN_number || "",
            GST: companyProfile?.Company_GST_number || "",
            // Company_MSME_number: companyProfile?.Company_MSME_number || "",
            Registered_Office_Address: companyProfile?.Company_address || "",
            Company_Mobile_number: companyProfile?.Company_Mobile_number || "",
            Company_email: companyProfile?.Company_email || "",

            Directors_of_Company: companyProfile?.Directors || [],
            Promoters_of_Company: companyProfile?.Directors || [],
            Authorised_Signatory:
                companyProfile?.Directors?.find(
                    d => d.Is_Authroized_signatory
                ) || {},
        };

        const finalPartB = {
            ...partb,

            // Functional_website_link:
            //     compliancedetails?.Web_portal_link || "",

            // Mobile_application_details:
            //     compliancedetails?.Mobile_application_link || "",

            Merchant_services_required:
                companyProfile?.Services_opted || [],

            Transaction_Ticket_Size:
                compliancedetails?.Services_opted_in_details || [],
        };

        const validateObject = (obj) => {
            return Object.values(obj).every(value => {

                if (Array.isArray(value)) {
                    return value.length > 0;
                }

                return value !== "" &&
                    value !== null &&
                    value !== undefined;
            });
        };
        //console.log(finalPartB);

        const isPartaComplete = validateObject(finalPartA);
        const isPartbComplete = validateObject(finalPartB);
        const isPartcComplete = validateObject(partc);

        if (!isPartaComplete || !isPartbComplete || !isPartcComplete) {
            message.error(
                'Please fill in all required details before submitting.'
            );
            return;
        }


        setSubmitloading(true);
        const response = await fetch('https://api.boompay.in/submit-merchant-due-deligence', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user}`,
            },
            body: JSON.stringify({
                ...finalPartA,
                ...finalPartB,
                ...partc,
                Company_profile_schema_id: companyProfile._id,
                Compliance_and_MAF_schema_id: compliancedetails._id,
                Bank_details_schema_id: banksdetails?._id,
                Completed_step: 5, // Update the Completed_step to 3 after submitting Merchant due diligence form
            })
        });
        const data = await response.json();
        if (response.status === 201) {
            message.success(data.message);
            getUserData();
            setSubmitloading(false);
        } else if (response.status === 400) {
            message.error(data.message);
            setSubmitloading(false);
        } else if (response.status === 404) {
            message.error(data.message);
            setSubmitloading(false);
        }
        else if (response.status === 401) {
            setSubmitloading(false);
            console.log('Unauthorized access. Please log in again.');
            message.error('Unauthorized access. Please log in again.');
        } else {
            setSubmitloading(false);
            console.log('An error occurred while submitting the form.');
            message.error('An error occurred while submitting the form.');
        }
    }

    const handleRectificationSubmit = async () => {
        const finalPartA = {
            ...parta,

            Registered_Name_of_Company: companyProfile?.Company_name || "",
            CIN: companyProfile?.Company_CIN_number || "",
            PAN: companyProfile?.Company_PAN_number || "",
            GST: companyProfile?.Company_GST_number || "",
            // Company_MSME_number: companyProfile?.Company_MSME_number || "",
            Registered_Office_Address: companyProfile?.Company_address || "",
            Company_Mobile_number: companyProfile?.Company_Mobile_number || "",
            Company_email: companyProfile?.Company_email || "",

            Directors_of_Company: companyProfile?.Directors || [],
            Promoters_of_Company: companyProfile?.Directors || [],
            Authorised_Signatory:
                companyProfile?.Directors?.find(
                    d => d.Is_Authroized_signatory
                ) || {},
        };

        const finalPartB = {
            ...partb,
            Merchant_services_required:
                companyProfile?.Services_opted || [],

            Transaction_Ticket_Size:
                compliancedetails?.Services_opted_in_details || [],
        };

        const validateObject = (obj) => {
            return Object.values(obj).every(value => {

                if (Array.isArray(value)) {
                    return value.length > 0;
                }

                return value !== "" &&
                    value !== null &&
                    value !== undefined;
            });
        };
        //console.log(finalPartB);

        const isPartaComplete = validateObject(finalPartA);
        const isPartbComplete = validateObject(finalPartB);
        const isPartcComplete = validateObject(partc);

        if (!isPartaComplete || !isPartbComplete || !isPartcComplete) {
            message.error(
                'Please fill in all required details before submitting.'
            );
            return;
        }
        setSubmitloading(true);
        try {
            const response = await fetch('https://api.boompay.in/put/rectify/merchant-due-deligence', {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                },
                body: JSON.stringify({
                    ...finalPartA,
                    ...finalPartB,
                    ...partc,
                    Company_profile_schema_id: submissionDetails?.Company_profile_schema_id
                })
            });
            const data = await response.json();
            if (response.status === 201) {
                //console.log(data.message);
                message.success(data?.message)
                onSuccess(); // Refresh user data to update.
                setSubmitloading(false);
            } else if (response.status === 400) {
                message.error(data.message);
                console.log(data.message);
            } else if (response.status === 401) {
                message.error('Unauthorized access. Please log in again.');
                console.log('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                message.error('User not found.');
                console.log('User not found.');
            } else {
                message.error('An error occurred while submitting company profile.');
                console.log('An error occurred while submitting company profile.');
            }
        } catch (error) {
            message.error('An error occurred while submitting company profile.');
            console.error('Error:', error);
        }
        setSubmitloading(false);
    }

    useEffect(() => {
        const getCompanyProfile = async () => {
            const response = await fetch('https://api.boompay.in/get-company-profile', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
            if (response.status === 200) {
                // console.log(data.Companyprofile);
                setCompanyProfile(data.Companyprofile);

                //  setUserprofile(data.user);
                // setActive(data.user.Completed_step);
                // setLoading(false);
            } else if (response.status === 401) {
                //setLoading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                // setLoading(false);
                console.log('Company profile not found.');
                message.error('Company profile not found.');
            } else {
                // setLoading(false);
                console.log('An error occurred while fetching data.');
                message.error('An error occurred while fetching data.');
            }
        }
        const getComplianceandmaf = async () => {
            const response = await fetch('https://api.boompay.in/get-compliance-details-and-maf', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
            if (response.status === 200) {
                // console.log(data.Complianceandmafdetails);
                setCompliancedetails(data.Complianceandmafdetails);

                //  setUserprofile(data.user);
                // setActive(data.user.Completed_step);
                // setLoading(false);
            } else if (response.status === 401) {
                //setLoading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                // setLoading(false);
                console.log('Compliance details not found.');
                message.error('Compliance details not found.');
            } else {
                // setLoading(false);
                console.log('An error occurred while fetching data.');
                message.error('An error occurred while fetching data.');
            }
        }
        const getbanksdetails = async () => {
            const response = await fetch('https://api.boompay.in/get-bank-details', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
            if (response.status === 200) {
                // console.log(data.Banksdetails);
                setbanksdetails(data.Banksdetails);

                //  setUserprofile(data.user);
                // setActive(data.user.Completed_step);
                // setLoading(false);
            } else if (response.status === 401) {
                //setLoading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                // setLoading(false);
                console.log('Banks details not found.');
                message.error('Banks details not found.');
            } else {
                // setLoading(false);
                console.log('An error occurred while fetching data.');
                message.error('An error occurred while fetching data.');
            }
        }

        if (user) {
            getCompanyProfile();
            getComplianceandmaf();
            getbanksdetails();
        }
    }, [user])

    useEffect(() => {
        const getUserData = async () => {
            setSubmitloading(true);
            const response = await fetch('https://api.boompay.in/get-submitted-details-for-rectification', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
            //console.log(data);

            if (response.status === 200) {
                const profile = data.RectificationDetails.Merchant_due_deligence_schema_id;
                // ==========================
                // PART A
                // ==========================
                setparta({
                    Registered_Name_of_Company: profile.Registered_Name_of_Company || "",
                    Registered_Office_Address: profile.Registered_Office_Address || "",
                    Constitution: profile.Constitution || "",
                    Date_of_Incorporation: profile.Date_of_Incorporation || "",
                    Directors_of_Company: profile.Directors_of_Company || [],
                    Promoters_of_Company: profile.Promoters_of_Company || [],
                    Authorised_Signatory: profile.Authorised_Signatory || [],
                    CIN: profile.CIN || "",
                    GST: profile.GST || "",
                    PAN: profile.PAN || "",
                    Annual_Business_Turnover_In_crorers:
                        profile.Annual_Business_Turnover_In_crorers || "",
                });

                // ==========================
                // PART B
                // ==========================

                setpartb({
                    Nature_of_Business_Use_case:
                        profile.Nature_of_Business_Use_case || "",

                    Mode_of_Business:
                        profile.Mode_of_Business || "",

                    Products_or_Service_to_be_sold_by_the_merchant:
                        profile.Products_or_Service_to_be_sold_by_the_merchant || "",

                    Transaction_Ticket_Size:
                        profile.Transaction_Ticket_Size || [],

                    Proposed_monthly_transaction_value_in_crores_to_be_processed_through:
                        profile.Proposed_monthly_transaction_value_in_crores_to_be_processed_through || "",

                    Functional_website_link:
                        profile.Functional_website_link || "",

                    Mobile_application_details:
                        profile.Mobile_application_details || "",

                    Invoice_generated_for_a_customer_through_merchant_site_application:
                        profile.Invoice_generated_for_a_customer_through_merchant_site_application || "",

                    Merchant_services_required:
                        profile.Merchant_services_required || [],

                    Proposed_MCC_as_per_business_case:
                        profile.Proposed_MCC_as_per_business_case || "",
                });

                // ==========================
                // PART C
                // ==========================

                setpartc({

                    Certificate_of_incorporation:
                        profile.Certificate_of_incorporation || "",

                    Article_of_association:
                        profile.Article_of_association || "",

                    Memorandum_of_Association:
                        profile.Memorandum_of_Association || "",

                    MCA_Data:
                        profile.MCA_Data || "",

                    Company_PAN:
                        profile.Company_PAN || "",

                    Company_GST:
                        profile.Company_GST || "",

                    MSME_Certificate:
                        profile.MSME_Certificate || "",

                    Cancelled_Cheque:
                        profile.Cancelled_Cheque || "",

                    Bank_Statement_last_3_months:
                        profile.Bank_Statement_last_3_months || "",

                    Balance_Sheet_for_Past_2_Financial_Years:
                        profile.Balance_Sheet_for_Past_2_Financial_Years || "",

                    GST_Returns_for_Past_2_Financial_Years:
                        profile.GST_Returns_for_Past_2_Financial_Years || "",

                    List_of_Directors_on_Company_Letter_Head:
                        profile.List_of_Directors_on_Company_Letter_Head || "",

                    Aadhar_and_PAN_and_Photo_of_all_Directors_for_KYC:
                        profile.Aadhar_and_PAN_and_Photo_of_all_Directors_for_KYC || "",

                    List_of_Promoters_on_Company_Letter_Head:
                        profile.List_of_Promoters_on_Company_Letter_Head || "",

                    Aadhar_and_PAN_of_all_Promoters_for_KYC:
                        profile.Aadhar_and_PAN_of_all_Promoters_for_KYC || "",

                    Board_Resolution_for_Authorised_Signatory:
                        profile.Board_Resolution_for_Authorised_Signatory || "",

                    Aadhar_and_PAN_and_Photo_of_Authorised_Signatory_for_KYC:
                        profile.Aadhar_and_PAN_and_Photo_of_Authorised_Signatory_for_KYC || "",

                    Office_Photo_with_company_board_disptay:
                        profile.Office_Photo_with_company_board_disptay || "",

                    Photo_of_Authorised_Signatory_Office_with_geo_location:
                        profile.Photo_of_Authorised_Signatory_Office_with_geo_location || "",

                    Merchant_Criminal_Undertaking:
                        profile.Merchant_Criminal_Undertaking || "",

                    invoice_Generated_for_a_Customer_Through_Merchants_Site_Application:
                        profile.invoice_Generated_for_a_Customer_Through_Merchants_Site_Application || "",
                });
                setSubmitloading(false);
            } else if (response.status === 401) {
                setSubmitloading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                setSubmitloading(false);
                console.log('User not found.');
                message.error('User not found.');
            } else {
                setSubmitloading(false);
                console.log('An error occurred while fetching user data.');
                message.error('An error occurred while fetching user data.');
            }
        }

        if (user && rectification) {
            getUserData();
        }
    }, [user, rectification])
    return (
        <>
            <Flex gap="medium" vertical>
                <Spin spinning={submitloading} size="large" description="Please wait...">
                    <Card title="Merchant Due Diligence" style={{ "box-shadow": "rgba(0, 0, 0, 0.24) 0px 3px 8px", }}>
                        <Alert type="warning" title="Please fill in all the required details as instructed. After completing the form, download the document and upload the signed copy on the company letterhead, duly stamped and signed by the authorized signatory." showIcon />
                        <Group mt={'sm'}>
                            <TextInput label="Company name" value={companyProfile?.Company_name || ""} disabled radius="xs" size="md" />
                            <TextInput label="Company CIN number" value={companyProfile?.Company_CIN_number || ""} disabled radius="xs" size="md" />
                            <TextInput label="Company PAN number" value={companyProfile?.Company_PAN_number || ""} disabled radius="xs" size="md" />
                            <TextInput label="GST number" value={companyProfile?.Company_GST_number || ""} disabled radius="xs" size="md" />
                            <TextInput label="MSME number" value={companyProfile?.Company_MSME_number || ""} disabled radius="xs" size="md" />
                            <TextInput label="Company address" value={companyProfile?.Company_address || ""} disabled radius="xs" size="md" />
                            <TextInput label="Company mobile number" value={companyProfile?.Company_Mobile_number || ""} disabled radius="xs" size="md" />
                            <TextInput label="Company email id" value={companyProfile?.Company_email || ""} disabled radius="xs" size="md" />
                        </Group>
                        <Divider label="Merchant Due Diligence" my="sm" variant="dashed" labelPosition="center" />
                        {/* <div ref={componentRef}> */}
                        <Paper withBorder shadow="sm" p="md" radius="xs" ref={componentRef}>
                            <TextInput variant="filled" radius="xs" size="xs" value="company refers to merchant who provides Product / services on its web site and/or mobile application, has to provide
the below details, on its letter head." disabled />
                            <Table mt={'xs'}>
                                <thead>
                                    <tr>
                                        <th style={{ width: '80px' }}>S.No</th>
                                        <th>Particulars</th>
                                        <th>Remarks</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {/* Section Heading */}
                                    <tr>
                                        <td><b>A</b></td>
                                        <td colSpan={2}>
                                            <b>Company Information</b>
                                        </td>
                                    </tr>

                                    {/* Row 1 */}
                                    <tr>
                                        <td>1</td>
                                        <td>Registered Name of Company</td>
                                        <td>
                                            <TextInput
                                                name='Registered_Name_of_Company'
                                                value={companyProfile?.Company_name || ""}
                                                // onChange={(e) => setparta({ ...parta, Registered_Name_of_Company: companyProfile?.Company_name })}
                                                disabled
                                                required
                                                variant="filled"
                                                radius="xs"
                                                size="sm"
                                            />
                                        </td>
                                    </tr>

                                    {/* Row 2 */}
                                    <tr>
                                        <td>2</td>
                                        <td>Registered Office Address</td>
                                        <td>
                                            <TextInput
                                                value={companyProfile?.Company_address || ""} disabled
                                                required
                                                variant="filled"
                                                radius="xs"
                                                size="sm"
                                            />
                                        </td>
                                    </tr>

                                    {/* Row 3 */}
                                    <tr>
                                        <td>3</td>
                                        <td>
                                            Constitution (Sole Proprietor / Partnership Firm /
                                            Private / Public / Others)
                                        </td>
                                        <td>
                                            <TextInput
                                                name='Constitution'
                                                value={parta.Constitution}
                                                onChange={handleChange}
                                                withAsterisk
                                                required
                                                // variant="filled"
                                                radius="xs"
                                                size="sm"
                                            />
                                        </td>
                                    </tr>

                                    {/* Row 4 */}
                                    <tr>
                                        <td>4</td>
                                        <td>Date of Incorporation</td>
                                        <td>
                                            <TextInput
                                                name='Date_of_Incorporation'
                                                value={parta.Date_of_Incorporation}
                                                onChange={handleChange}
                                                withAsterisk
                                                required
                                                // variant="filled"
                                                radius="xs"
                                                size="sm"
                                            />
                                        </td>
                                    </tr>

                                    {/* Row 5 */}
                                    <tr>
                                        <td>5</td>
                                        <td>Directors of Company</td>
                                        <td>
                                            {
                                                companyProfile?.Directors.map((director, index) => {
                                                    return (
                                                        <Textarea
                                                            value={`Director ${index + 1}: ${director.Director_name}, DIN: ${director.Director_DIN_number}`} disabled
                                                            required
                                                            // variant="filled"
                                                            radius="xs"
                                                            size="sm"
                                                        />

                                                    )
                                                })
                                            }

                                        </td>
                                    </tr>

                                    {/* Row 6 */}
                                    <tr>
                                        <td>6</td>
                                        <td>Promoters of Company</td>
                                        <td>
                                            {
                                                companyProfile?.Directors.map((director, index) => {
                                                    return (
                                                        <Textarea
                                                            value={`Promoters ${index + 1}: ${director.Director_name},`} disabled
                                                            required
                                                            // variant="filled"
                                                            radius="xs"
                                                            size="sm"
                                                        />

                                                    )
                                                })
                                            }
                                        </td>
                                    </tr>

                                    {/* Row 7 */}
                                    <tr>
                                        <td>7</td>
                                        <td>Authorised Signatory</td>
                                        <td>
                                            <Textarea
                                                value={
                                                    `Authorized Director: ${companyProfile?.Directors?.find(d => d.Is_Authroized_signatory)?.Director_name || ""}

Mobile Number: ${companyProfile?.Directors?.find(d => d.Is_Authroized_signatory)?.Director_mobile_number || ""}

Email ID: ${companyProfile?.Directors?.find(d => d.Is_Authroized_signatory)?.Director_email || ""}

DIN Number: ${companyProfile?.Directors?.find(d => d.Is_Authroized_signatory)?.Director_DIN_number || ""}

Share Percentage: ${companyProfile?.Directors?.find(d => d.Is_Authroized_signatory)?.Share_perecentage || ""}%`
                                                }
                                                disabled
                                                required
                                                radius="xs"
                                                size="sm"
                                                autosize
                                                minRows={6}
                                            />
                                        </td>
                                    </tr>

                                    {/* Row 8 */}
                                    <tr>
                                        <td>8</td>
                                        <td>CIN</td>
                                        <td>
                                            <TextInput
                                                value={companyProfile?.Company_CIN_number || ""} disabled
                                                required
                                                variant="filled"
                                                radius="xs"
                                                size="sm"
                                            />
                                        </td>
                                    </tr>

                                    {/* Row 9 */}
                                    <tr>
                                        <td>9</td>
                                        <td>GST / ARN</td>
                                        <td>
                                            <TextInput
                                                value={companyProfile?.Company_GST_number || ""} disabled
                                                required
                                                variant="filled"
                                                radius="xs"
                                                size="sm"
                                            />
                                        </td>
                                    </tr>
                                    {/* Row 10 */}
                                    <tr>
                                        <td>10</td>
                                        <td>PAN</td>
                                        <td>
                                            <TextInput
                                                value={companyProfile?.Company_PAN_number || ""} disabled
                                                required
                                                variant="filled"
                                                radius="xs"
                                                size="sm"
                                            />
                                        </td>
                                    </tr>
                                    {/* Row 11 */}
                                    <tr>
                                        <td>11</td>
                                        <td>Annual Business Turnover (In crorers)</td>
                                        <td>
                                            <TextInput
                                                name='Annual_Business_Turnover_In_crorers'
                                                value={parta.Annual_Business_Turnover_In_crorers}
                                                onChange={handleChange}
                                                required
                                                // variant="filled"
                                                radius="xs"
                                                size="sm"
                                            />
                                        </td>
                                    </tr>
                                    {/* Row 12 */}
                                    {/* ===================== B SECTION ===================== */}

                                    <tr>
                                        <td>
                                            <b>B</b>
                                        </td>

                                        <td colSpan={2}>
                                            <b>Business / Product Information</b>
                                        </td>
                                    </tr>

                                    {/* Row 1 */}
                                    <tr>
                                        <td>1</td>

                                        <td>Nature of Business (Use Case)</td>

                                        <td>
                                            <Textarea
                                                name='Nature_of_Business_Use_case'
                                                value={partb.Nature_of_Business_Use_case}
                                                onChange={handleChnangePartb}
                                                required
                                                // variant="filled"
                                                radius="xs"
                                                size="sm"
                                                // placeholder="Enter nature of business / use case"
                                                autosize
                                                minRows={3}
                                            />
                                        </td>
                                    </tr>

                                    {/* Row 2 */}
                                    <tr>
                                        <td>2</td>

                                        <td>Mode of Business (Online/Offline/Both)</td>

                                        <td>
                                            <Textarea
                                                name='Mode_of_Business'
                                                value={partb.Mode_of_Business}
                                                onChange={handleChnangePartb}
                                                required
                                                // variant="filled"
                                                radius="xs"
                                                size="sm"
                                                // placeholder="Describe your business model"
                                                autosize
                                                minRows={3}
                                            />
                                        </td>
                                    </tr>

                                    {/* Row 3 */}
                                    <tr>
                                        <td>3</td>

                                        <td>Products/Service to be sold by the merchant</td>

                                        <td>
                                            <Textarea
                                                name='Products_or_Service_to_be_sold_by_the_merchant'
                                                value={partb.Products_or_Service_to_be_sold_by_the_merchant}
                                                onChange={handleChnangePartb}
                                                required
                                                // variant="filled"
                                                radius="xs"
                                                size="sm"
                                                // placeholder="Enter products or services offered"
                                                autosize
                                                minRows={3}
                                            />
                                        </td>
                                    </tr>

                                    {/* Row 4 */}
                                    <tr>
                                        <td>4</td>

                                        <td>Transaction Ticket Size (Min / Avg / Max)</td>

                                        <td>
                                            <Stack gap={6}>
                                                {compliancedetails?.Services_opted_in_details.map(
                                                    (txndetails, index) => (
                                                        <Paper
                                                            key={index}
                                                            p="xs"
                                                            withBorder
                                                            radius="md"
                                                        >
                                                            <Text size="sm" fw={600}>
                                                                {index + 1}. {txndetails?.Service_name?.[0]}
                                                            </Text>

                                                            <Text size="xs">
                                                                Use Case: {txndetails?.Use_case_of_this_service}
                                                            </Text>

                                                            <Text size="xs">
                                                                Daily Txn: {txndetails?.Expected_daily_transaction}
                                                            </Text>

                                                            <Text size="xs">
                                                                Monthly Business: ₹
                                                                {txndetails?.Expected_monthly_business_for_this_service}
                                                            </Text>

                                                            <Text size="xs">
                                                                Ticket Size:
                                                                Min ₹{txndetails?.Min_ticket_size} |
                                                                Avg ₹{txndetails?.Average_ticket_size} |
                                                                Max ₹{txndetails?.Max_ticket_size}
                                                            </Text>
                                                        </Paper>
                                                    )
                                                )}
                                            </Stack>
                                        </td>
                                    </tr>

                                    {/* Row 5 */}
                                    <tr>
                                        <td>5</td>

                                        <td>Proposed monthly transaction value in crores to be processed through</td>

                                        <td>
                                            <TextInput
                                                name='Proposed_monthly_transaction_value_in_crores_to_be_processed_through'
                                                value={partb.Proposed_monthly_transaction_value_in_crores_to_be_processed_through}
                                                onChange={handleChnangePartb}
                                                required
                                                // variant="filled"
                                                radius="xs"
                                                size="sm"
                                            // placeholder="Enter expected monthly transaction volume"
                                            />
                                        </td>
                                    </tr>

                                    {/* Row 6 */}
                                    <tr>
                                        <td>6</td>

                                        <td>Functional website link</td>

                                        <td>
                                            <TextInput
                                                name='Functional_website_link'
                                                value={partb.Functional_website_link}
                                                onChange={handleChnangePartb}
                                                required
                                                // variant="filled"
                                                radius="xs"
                                                size="sm"
                                            // placeholder="Enter average ticket size"
                                            />
                                        </td>
                                    </tr>

                                    {/* Row 7 */}
                                    <tr>
                                        <td>7</td>

                                        <td>Mobile application details</td>

                                        <td>
                                            <TextInput
                                                name='Mobile_application_details'
                                                value={partb.Mobile_application_details}
                                                onChange={handleChnangePartb}
                                                //required
                                                // variant="filled"
                                                radius="xs"
                                                size="sm"
                                            // placeholder="Enter maximum ticket size"
                                            />
                                        </td>
                                    </tr>

                                    {/* Row 8 */}
                                    <tr>
                                        <td>8</td>

                                        <td>Invoice generated for a customer through merchant site/application </td>

                                        <td>
                                            <Textarea
                                                name='Invoice_generated_for_a_customer_through_merchant_site_application'
                                                value={partb.Invoice_generated_for_a_customer_through_merchant_site_application}
                                                onChange={handleChnangePartb}
                                                required
                                                // variant="filled"
                                                radius="xs"
                                                size="sm"
                                                placeholder="Yes/No"
                                                autosize
                                                minRows={2}
                                            />
                                        </td>
                                    </tr>

                                    {/* Row 9 */}
                                    <tr>
                                        <td>9</td>

                                        <td>Merchant services required</td>

                                        <td>
                                            <Stack gap={6}>
                                                {compliancedetails?.Services_opted_in_details.map(
                                                    (txndetails, index) => (
                                                        <Paper
                                                            key={index}
                                                            p="xs"
                                                            withBorder
                                                            radius="md"
                                                        >
                                                            <Text size="sm" fw={600}>
                                                                {index + 1}. {txndetails?.Service_name?.[0]}
                                                            </Text>


                                                        </Paper>
                                                    )
                                                )}
                                            </Stack>
                                        </td>
                                    </tr>

                                    {/* Row 10 */}
                                    <tr>
                                        <td>10</td>

                                        <td>Proposed MCC as per business case</td>

                                        <td>
                                            <Textarea
                                                name='Proposed_MCC_as_per_business_case'
                                                value={partb.Proposed_MCC_as_per_business_case}
                                                onChange={handleChnangePartb}
                                                required
                                                // variant="filled"
                                                radius="xs"
                                                size="sm"
                                                // placeholder="Enter website or mobile application details"
                                                autosize
                                                minRows={2}
                                            />
                                        </td>
                                    </tr>

                                    {/* ===================== C SECTION ===================== */}

                                    <tr>
                                        <td>
                                            <b>C</b>
                                        </td>

                                        <td colSpan={2}>
                                            <b>Documents to be provided by merchant</b>
                                        </td>
                                    </tr>

                                    {/* Row 1 */}
                                    <tr>
                                        <td>1</td>

                                        <td>Certificate of incorporation (Yes/No)</td>

                                        <td>
                                            <Textarea
                                                // variant="filled"
                                                name='Certificate_of_incorporation'
                                                value={partc.Certificate_of_incorporation}
                                                onChange={handleChnangePartc}
                                                required
                                                radius="xs"
                                                size="sm"
                                                placeholder="Yes/No"
                                                autosize
                                                minRows={2}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>2</td>

                                        <td>Article of association (Yes/No)</td>

                                        <td>
                                            <Textarea
                                                name='Article_of_association'
                                                value={partc.Article_of_association}
                                                onChange={handleChnangePartc}
                                                required
                                                // variant="filled"
                                                radius="xs"
                                                size="sm"
                                                placeholder="Yes/No"
                                                autosize
                                                minRows={2}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>3</td>

                                        <td>Memorandum of Association  (Yes/No)</td>

                                        <td>
                                            <Textarea
                                                name='Memorandum_of_Association'
                                                value={partc.Memorandum_of_Association}
                                                onChange={handleChnangePartc}
                                                required
                                                //variant="filled"
                                                radius="xs"
                                                size="sm"
                                                placeholder="Yes/No"
                                                autosize
                                                minRows={2}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>4</td>

                                        <td>MCA Data   (Yes/No)</td>

                                        <td>
                                            <Textarea
                                                name='MCA_Data'
                                                value={partc.MCA_Data}
                                                onChange={handleChnangePartc}
                                                required
                                                // variant="filled"
                                                radius="xs"
                                                size="sm"
                                                placeholder="Yes/No"
                                                autosize
                                                minRows={2}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>5</td>

                                        <td>Company PAN   (Yes/No)</td>

                                        <td>
                                            <Textarea
                                                name='Company_PAN'
                                                value={partc.Company_PAN}
                                                onChange={handleChnangePartc}
                                                required
                                                // variant="filled"
                                                radius="xs"
                                                size="sm"
                                                placeholder="Yes/No"
                                                autosize
                                                minRows={2}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>6</td>

                                        <td>Company GST   (Yes/No)</td>

                                        <td>
                                            <Textarea
                                                name='Company_GST'
                                                value={partc.Company_GST}
                                                onChange={handleChnangePartc}
                                                required
                                                // variant="filled"
                                                radius="xs"
                                                size="sm"
                                                placeholder="Yes/No"
                                                autosize
                                                minRows={2}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>7</td>

                                        <td>MSME Certificate   (Yes/No)</td>

                                        <td>
                                            <Textarea
                                                name='MSME_Certificate'
                                                value={partc.MSME_Certificate}
                                                onChange={handleChnangePartc}
                                                required
                                                //  variant="filled"
                                                radius="xs"
                                                size="sm"
                                                placeholder="Yes/No"
                                                autosize
                                                minRows={2}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>8</td>

                                        <td>Cancelled Cheque  (Yes/No)</td>

                                        <td>
                                            <Textarea
                                                name='Cancelled_Cheque'
                                                value={partc.Cancelled_Cheque}
                                                onChange={handleChnangePartc}
                                                required
                                                //  variant="filled"
                                                radius="xs"
                                                size="sm"
                                                placeholder="Yes/No"
                                                autosize
                                                minRows={2}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>9</td>

                                        <td>Bank Statement last 3 months   (Yes/No)</td>

                                        <td>
                                            <Textarea
                                                name='Bank_Statement_last_3_months'
                                                value={partc.Bank_Statement_last_3_months}
                                                onChange={handleChnangePartc}
                                                required
                                                // variant="filled"
                                                radius="xs"
                                                size="sm"
                                                placeholder="Yes/No"
                                                autosize
                                                minRows={2}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>10</td>

                                        <td>Balance Sheet for Past 2 Financial Years   (Yes/No)</td>

                                        <td>
                                            <Textarea
                                                name='Balance_Sheet_for_Past_2_Financial_Years'
                                                value={partc.Balance_Sheet_for_Past_2_Financial_Years}
                                                onChange={handleChnangePartc}
                                                required
                                                // variant="filled"
                                                radius="xs"
                                                size="sm"
                                                placeholder="Yes/No"
                                                autosize
                                                minRows={2}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>11</td>

                                        <td>GST Returns for Past 2 Financial Years  (Yes/No)</td>

                                        <td>
                                            <Textarea
                                                name='GST_Returns_for_Past_2_Financial_Years'
                                                value={partc.GST_Returns_for_Past_2_Financial_Years}
                                                onChange={handleChnangePartc}
                                                required
                                                // variant="filled"
                                                radius="xs"
                                                size="sm"
                                                placeholder="Yes/No"
                                                autosize
                                                minRows={2}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>12</td>

                                        <td>List of Directors on Company Letter Head (Yes/No)</td>

                                        <td>
                                            <Textarea
                                                name='List_of_Directors_on_Company_Letter_Head'
                                                value={partc.List_of_Directors_on_Company_Letter_Head}
                                                onChange={handleChnangePartc}
                                                required
                                                //  variant="filled"
                                                radius="xs"
                                                size="sm"
                                                placeholder="Yes/No"
                                                autosize
                                                minRows={2}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>13</td>

                                        <td>Aadhar and PAN and Photo of all Directors
                                            for KYC (Yes/No)</td>

                                        <td>
                                            <Textarea
                                                name='Aadhar_and_PAN_and_Photo_of_all_Directors_for_KYC'
                                                value={partc.Aadhar_and_PAN_and_Photo_of_all_Directors_for_KYC}
                                                onChange={handleChnangePartc}
                                                required
                                                // variant="filled"
                                                radius="xs"
                                                size="sm"
                                                placeholder="Yes/No"
                                                autosize
                                                minRows={2}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>14</td>

                                        <td>List of Promoters on Company Letter Head   (Yes/No)</td>

                                        <td>
                                            <Textarea
                                                name='List_of_Promoters_on_Company_Letter_Head'
                                                value={partc.List_of_Promoters_on_Company_Letter_Head}
                                                onChange={handleChnangePartc}
                                                required
                                                // variant="filled"
                                                radius="xs"
                                                size="sm"
                                                placeholder="Yes/No"
                                                autosize
                                                minRows={2}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>15</td>

                                        <td>Aadhar and PAN of all Promoters for KYC  (Yes/No)</td>

                                        <td>
                                            <Textarea
                                                name='Aadhar_and_PAN_of_all_Promoters_for_KYC'
                                                value={partc.Aadhar_and_PAN_of_all_Promoters_for_KYC}
                                                onChange={handleChnangePartc}
                                                required
                                                // variant="filled"
                                                radius="xs"
                                                size="sm"
                                                placeholder="Yes/No"
                                                autosize
                                                minRows={2}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>16</td>

                                        <td>Board Resolution for Authorised Signatory
                                            (Attached)   (Yes/No)</td>

                                        <td>
                                            <Textarea
                                                name='Board_Resolution_for_Authorised_Signatory'
                                                value={partc.Board_Resolution_for_Authorised_Signatory}
                                                onChange={handleChnangePartc}
                                                required
                                                // variant="filled"
                                                radius="xs"
                                                size="sm"
                                                placeholder="Yes/No"
                                                autosize
                                                minRows={2}
                                            />
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>17</td>

                                        <td>Aadhar and PAN and Photo of Authorised
                                            Signatory for KYC  (Yes/No)</td>

                                        <td>
                                            <Textarea
                                                name='Aadhar_and_PAN_and_Photo_of_Authorised_Signatory_for_KYC'
                                                value={partc.Aadhar_and_PAN_and_Photo_of_Authorised_Signatory_for_KYC}
                                                onChange={handleChnangePartc}
                                                required
                                                // variant="filled"
                                                radius="xs"
                                                size="sm"
                                                placeholder="Yes/No"
                                                autosize
                                                minRows={2}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>18</td>

                                        <td>Office Photo with company board
                                            disptay (Yes/No)</td>

                                        <td>
                                            <Textarea
                                                name='Office_Photo_with_company_board_disptay'
                                                value={partc.Office_Photo_with_company_board_disptay}
                                                onChange={handleChnangePartc}
                                                required
                                                // variant="filled"
                                                radius="xs"
                                                size="sm"
                                                placeholder="Yes/No"
                                                autosize
                                                minRows={2}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>19</td>

                                        <td>Photo of Authorised Signatory Office with
                                            geo location (Yes/No)</td>

                                        <td>
                                            <Textarea
                                                name='Photo_of_Authorised_Signatory_Office_with_geo_location'
                                                value={partc.Photo_of_Authorised_Signatory_Office_with_geo_location}
                                                onChange={handleChnangePartc}
                                                required
                                                //  variant="filled"
                                                radius="xs"
                                                size="sm"
                                                placeholder="Yes/No"
                                                autosize
                                                minRows={2}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>20</td>

                                        <td>Merchant Criminal Undertaking (Attached) (Yes/No)</td>

                                        <td>
                                            <Textarea
                                                name='Merchant_Criminal_Undertaking'
                                                value={partc.Merchant_Criminal_Undertaking}
                                                onChange={handleChnangePartc}
                                                required
                                                // variant="filled"
                                                radius="xs"
                                                size="sm"
                                                placeholder="Yes/No"
                                                autosize
                                                minRows={2}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>21</td>

                                        <td>invoice Generated for a Customer Through
                                            Merchant's Site Application (Yes/No)</td>

                                        <td>
                                            <Textarea
                                                name='invoice_Generated_for_a_Customer_Through_Merchants_Site_Application'
                                                value={partc.invoice_Generated_for_a_Customer_Through_Merchants_Site_Application}
                                                onChange={handleChnangePartc}
                                                required
                                                // variant="filled"
                                                radius="xs"
                                                size="sm"
                                                placeholder="Yes/No"
                                                autosize
                                                minRows={2}
                                            />
                                        </td>
                                    </tr>


                                </tbody>
                            </Table>
                        </Paper>
                        {/* </div> */}

                        {/* {banks.map((bank, index) => (
                            <Group key={index} mt={'lg'}>
                                <TextInput
                                    label="Bank name"
                                    value={bank.bank_name}
                                    onChange={(e) => handleChange(index, "bank_name", e.target.value)}
                                    required
                                    variant="filled"
                                    radius="xs"
                                    size="md"
                                />

                                <TextInput
                                    label="Account number"
                                    value={bank.account_number}
                                    onChange={(e) => handleChange(index, "account_number", e.target.value)}
                                    required
                                    variant="filled"
                                    radius="xs"
                                    size="md"
                                />

                                <TextInput
                                    label="IFSC code"
                                    value={bank.ifsc_code}
                                    onChange={(e) => handleChange(index, "ifsc_code", e.target.value)}
                                    required
                                    variant="filled"
                                    radius="xs"
                                    size="md"
                                />

                                <TextInput
                                    label="Branch"
                                    value={bank.bank_branch}
                                    onChange={(e) => handleChange(index, "bank_branch", e.target.value)}
                                    required
                                    variant="filled"
                                    radius="xs"
                                    size="md"
                                />

                                <Button mt="xs" onClick={addBanks} size="xs" variant="light">
                                    + Add Bank
                                </Button>
                                {banks.length > 1 && (
                                    <Button
                                        mt="xs"
                                        color="red"
                                        variant="light"
                                        onClick={() => removeBanks(index)}
                                        size="xs"
                                    >
                                        - Remove Bank
                                    </Button>
                                )}
                            </Group>
                        ))} */}
                        <Group justify="end">
                            <Button mt={'md'} size="lg" color="teal" variant="light" onClick={handlePrint}>Print Merchant Due Diligence</Button>
                            {/* <Button mt={'md'} size="lg" color="lime" variant="light" onClick={handelSubmit} loading={submitloading}>Save changes</Button> */}
                            <Button
                                mt={'md'}
                                size="lg"
                                color="lime"
                                variant="light"
                                loading={submitloading}
                                onClick={
                                    rectification
                                        ? handleRectificationSubmit
                                        : handelSubmit
                                }
                            >
                                {
                                    rectification
                                        ? "Submit Rectification"
                                        : "Save Changes"
                                }
                            </Button>
                        </Group>

                    </Card>
                </Spin>
            </Flex>

        </>
    )
}
export default Merchantduedeligence